











import Vue from 'vue'
import moment from 'moment'

interface Props {
  filterValue: string
}
interface Data {
  inputValue: string[]
}

interface Methods {
  changeInput: () => void
  setValues: () => void
}

export default Vue.extend<Data, Methods, {}, Props>({
  props: {
    filterValue: {
      required: true,
    },
  },
  data() {
    return {
      inputValue: ['00:00:00', '00:00:00'],
    }
  },
  methods: {
    changeInput() {
      const newFilterValue =
        moment.duration(this.inputValue[0]).asSeconds() +
        '-' +
        moment.duration(this.inputValue[1]).asSeconds()
      this.$emit('input', newFilterValue)
    },
    setValues() {
      if (this.filterValue) {
        this.inputValue = this.filterValue.split('-').map(elem => {
          return moment
            .utc(Number(elem) * 1000)
            .local()
            .format('HH:mm:ss')
        })
      }
    },
  },
  mounted() {
    this.setValues()
  },
  watch: {
    '$route.query.filter'() {
      this.setValues()
    },
  },
})
